import { createToolbarButton } from '../../../components/toolbar-button/toolbar-button-factory';
import {translate} from 'shared/services/I18nService';

const BUTTON_CLASS = 'uscope-snapshot-button';
const BUTTON_HOVER_TEXT = 'uScope.extensions.snapshot.toolbar-icon-alt-text';

export const createButton = (settingsButton, onClick) => {
  // Create a button to add to uScope's toolbar.
  const button = createToolbarButton({
    className: BUTTON_CLASS,

    title: translate(BUTTON_HOVER_TEXT),

    onClick
  });

  // Setup the button UI that includes the settings button
  const container = document.createElement('div');
  container.classList.add('toolbar-button-container');
  container.appendChild(button);
  container.appendChild(settingsButton);

  return container;
};
